import { interpolateLab } from "d3-interpolate";
const gradient = interpolateLab("rgb(82, 58, 223)", "rgb(143, 243, 196)");
export default gradient;
